import { apiPath } from '../../constants';
import { axios, apiRequestOptions, errorRequestHandler, transformHttpResponse } from 'utils';

export const SCHEDULE_GENERATE_REQUEST = 'SCHEDULE_GENERATE_REQUEST';
export const SCHEDULE_GENERATE_SUCCESS = 'SCHEDULE_GENERATE_SUCCESS';
export const SCHEDULE_GENERATE_FAILURE = 'SCHEDULE_GENERATE_FAILURE';

export const generateSchedule = (competitionId) => {
  return function (dispatch) {
    dispatch({ type: SCHEDULE_GENERATE_REQUEST });
    return axios(apiRequestOptions(apiPath.SCHEDULE.GENERATE, { competitionId }))
      .then(transformHttpResponse)
      .then(response => dispatch({ type: SCHEDULE_GENERATE_SUCCESS, data: response.data }))
      .catch(error => transformHttpResponse(error.response))
      .catch(error => {
        dispatch({ type: SCHEDULE_GENERATE_FAILURE, error });
        dispatch(errorRequestHandler(error));
      });
  };
};
